<script>
export default {
  name: 'CancelDialogBox',
  props: {

  },
  data: () => ({

  }),
  methods: {
    cancel () {
      this.$emit('cancel');
    },
    confirm () {
      this.$emit('confirm');
    },
  },
};
</script>

<template lang="pug">
  div.cancel-dialog-box.flex.flex-column.white.relative
    .bg-black-dark-overlay._collision.overflow-hidden.relative
      header.cf.pa4.ph5.flex-auto.tc
        //- i18n.title.fw7.f2.mv3.lh-title(path="{game}", tag="h1")
        //-   span(place="game") #[br]{{ localGame && localGame.title }}!
        h2.subtitle.f5.mv4.lh-copy {{ $t('Are you sure you want to cancel and go back to the launcher?') }}
    div.buttons.flex.mt2.f5
      cta-style
        button.cancelbtn.b--black.pa3.w-50.mr2(type="button" @click="cancel")
          | no
      cta-style
        button.confirmbtn.b--black.bg-black-overlay.pa3.w-50.-accent(v-sound="'progress'" type="button" @click="confirm")
          | yes

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cancel-dialog-box {
}
</style>
